import { MultiSelect } from "@/components/ui/multi-select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface LicenseFieldsProps {
  profile: any;
  setProfile: (profile: any) => void;
  readOnly: boolean;
}

export function LicenseFields({
  profile,
  setProfile,
  readOnly
}: LicenseFieldsProps) {
  return (
    <>
      <div className="space-y-1">
        <div className="flex items-center gap-1">
          <label className="text-sm font-medium">Führerschein</label>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <HelpCircle className="h-4 w-4 text-gray-400" />
              </TooltipTrigger>
              <TooltipContent>
                <p>Besitzt du einen gültigen Führerschein?</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <MultiSelect
          disabled={readOnly}
          options={[
            { value: "none", label: "Nein" },
            { value: "b", label: "Führerschein Klasse B" },
            { value: "c1", label: "Führerscheinklasse C1 (3,5 t bis 7,5 t)" },
            { value: "c", label: "Führerscheinklasse C (> 7,5 t)" }
          ]}
          selectedValues={profile?.drivers_license || []}
          onValueChange={(values) =>
            setProfile({ ...profile!, drivers_license: values })
          }
          placeholder="Führerschein auswählen"
          maxCount={3}
        />
      </div>
      {profile?.drivers_license &&
        profile.drivers_license.length > 0 &&
        !profile.drivers_license.includes("none") && (
          <div className="space-y-1">
            <div className="flex items-center gap-1">
              <label className="text-sm font-medium">
                Deutscher Führerschein
              </label>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <HelpCircle className="h-4 w-4 text-gray-400" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Hast du einen deutschen Führerschein?</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <MultiSelect
              options={[
                { value: "none", label: "Nein" },
                { value: "b", label: "Führerschein Klasse B" },
                {
                  value: "c1",
                  label: "Führerscheinklasse C1 (3,5 t bis 7,5 t)"
                },
                { value: "c", label: "Führerscheinklasse C (> 7,5 t)" }
              ]}
              selectedValues={profile?.german_drivers_license || []}
              onValueChange={(values) =>
                setProfile({
                  ...profile!,
                  german_drivers_license: values
                })
              }
              placeholder="Deutschen Führerschein auswählen"
              maxCount={3}
            />
          </div>
        )}
    </>
  );
}
